import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import iotLogo from './logo/iot_logo.png';

const useStyles = makeStyles(theme => ({
  logo: {
    // Indiana Office of Technology wordmark (420x105). Sized to sit comfortably
    // in the open sidebar rail; height derives from the aspect ratio.
    width: theme.spacing(22),
    height: 'auto',
    maxWidth: '100%',
  },
  // The IOT wordmark is a wide 612x300 PNG with white text on a transparent
  // background; it needs the full rail width to stay legible.
  logoWide: {
    width: theme.spacing(26),
    height: 'auto',
  },
}));

type Branding = {
  logoFullSrc?: string;
  logoFullAlt?: string;
  logoFullWide?: boolean;
};

const LogoFull = () => {
  const classes = useStyles();
  const branding: Branding = (useTheme().palette as any).branding ?? {};
  return (
    <img
      alt={branding.logoFullAlt ?? 'Indiana Office of Technology'}
      src={branding.logoFullSrc ?? iotLogo}
      className={branding.logoFullWide ? classes.logoWide : classes.logo}
    />
  );
};

export default LogoFull;
